import { takeEvery, call, put, all, fork } from "redux-saga/effects";
import { SIGNUP } from "./action";
import { actionCreators as actionCreatorsLogin } from "../LogIn/action";
import { actionCreators as actionCreatorsForgotPassword } from "../ForgotPassword/action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";
import { actionCreators as actionCreatorsSpinner } from "../Spinner/action";
import { enumChecker } from "../../common/helpers/checker";

export function* onSignUpSaga(action) {
  const { email, password, repeatpassword, redirect, checked } = action.payload;

  if (checked) {
    if (password === repeatpassword) {
      try {
        yield put(actionCreatorsSpinner.showSpinner());
        const user = yield call(
          reduxSagaFirebase.auth.createUserWithEmailAndPassword,
          email,
          password
        );
        yield call(action.payload.redirect, "SignIn");

        // redirect to login page
        // zaloguj
        yield put(actionCreatorsLogin.login({ email, password, redirect }));
      } catch (error) {
        yield put(actionCreatorsSpinner.hideSpinner());
        yield put(actionCreatorsForgotPassword.saveErrorReponse(error));
      }
    } else {
      const error = {
        code: enumChecker.differentPasswords,
        message: "The passwords do not matched.",
      };
      yield put(actionCreatorsForgotPassword.saveErrorReponse(error));
    }
  } else {
    const error = {
      code: enumChecker.agreementNotChecked,
      message: "The agreement do not checked.",
    };
    yield put(actionCreatorsForgotPassword.saveErrorReponse(error));
  }
}

export function* signUpSaga() {
  yield takeEvery(SIGNUP, onSignUpSaga);
}

export function* registrationFormSaga() {
  yield all([fork(signUpSaga)]);
}
